import React from 'react';

import ShowMetrics, { TYPE_METRICS } from '../../helpers/ShowMetrics';

function WithdrawalMetrics() {
    const url = '/crea/api/metrics';

    return (
        <div className="row metrics">
            <ShowMetrics
                url={url}
                path="withdrawal/new"
                label="New Withdrawals"
                typeMetrics={TYPE_METRICS.VALUE_METRIC}
            />
            <ShowMetrics
                url={url}
                path="withdrawal/per_day"
                label="Withdrawals per Day"
                typeMetrics={TYPE_METRICS.TREND_METRIC}
            />
            <ShowMetrics
                url={url}
                path="withdrawal/sum"
                label="Sum of Withdrawals"
                typeMetrics={TYPE_METRICS.TREND_METRIC}
            />
        </div>
    );
}

export default WithdrawalMetrics;
